import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import Button from '../ui/Button';
import Container from '../ui/Container';

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-32">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>
      
      <Container>
        <div className="relative text-center max-w-5xl mx-auto">
          <div className="inline-flex items-center bg-white/10 rounded-full px-6 py-2 mb-8">
            <Sparkles className="w-5 h-5 mr-2 text-yellow-300" />
            <span className="text-sm">Join thousands of successful students</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight">
            Transform Your Learning Journey
            <span className="block text-3xl md:text-4xl mt-4 font-normal text-indigo-200">
              One-on-One with Expert Teachers
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-12 text-indigo-100 max-w-3xl mx-auto">
            Experience personalized learning sessions tailored to your needs and schedule. 
            Learn at your own pace with dedicated mentors.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/teachers">
              <Button variant="secondary" size="lg" className="group">
                Find Your Teacher
                {/* <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" /> */}
              </Button>
            </Link>
            {/* <Link to="/become-teacher">
              <Button variant="outline" size="lg">
                Become a Teacher
              </Button>
            </Link> */}
          </div>

          {/* <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80"
                alt="Student learning"
                className="w-48 h-48 object-cover rounded-xl mx-auto mb-4 shadow-lg"
              />
              <p className="text-indigo-200">Learn from anywhere</p>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80"
                alt="Online teaching"
                className="w-48 h-48 object-cover rounded-xl mx-auto mb-4 shadow-lg"
              />
              <p className="text-indigo-200">Expert guidance</p>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1571260899304-425eee4c7efc?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80"
                alt="Student success"
                className="w-48 h-48 object-cover rounded-xl mx-auto mb-4 shadow-lg"
              />
              <p className="text-indigo-200">Achieve your goals</p>
            </div>
          </div> */}
        </div>
      </Container>
    </section>
  );
};

export default HeroSection;